module.exports = __webpack_public_path__ + "img/qa_rc.574785a7.svg";